/**
 * DocListTableLayout Component
 *
 * Outer container for the DocList table.
 * Uses absolute positioning to fill parent container.
 * Provides scroll container for virtualization.
 * In card mode the content is sized to the container and never scrolls sideways.
 */

import { FC, ReactNode, RefObject } from 'react';
import { theme } from 'antd';

interface DocListTableLayoutProps {
  children: ReactNode;
  scrollRef?: RefObject<HTMLDivElement | null>;
  cardMode?: boolean;
}

const DocListTableLayout: FC<DocListTableLayoutProps> = ({
  children,
  scrollRef,
  cardMode = false,
}) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadius,
        backgroundColor: token.colorBgContainer,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        ref={scrollRef}
        aria-label="doclist-table-container"
        role="table"
        style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: cardMode ? 'hidden' : 'auto',
          minHeight: 0,
        }}
      >
        <div
          style={{
            minWidth: cardMode ? undefined : 'max-content',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default DocListTableLayout;

